module.exports = __webpack_public_path__ + "static/media/bytt-nn-10.6ec3a96d.mp3";